/**
 * 日付文字列を求人件数更新日に変換する
 * @remarks
 *  doda-site-web/doda-files/WebContent/resources/dcfront/js/cmsParts.js より抜粋
 * @param {string} dateText - 形式: YYYY/MM/DD
 * @returns {string} 更新日
 */
export const convertDateToJobCountUpdateDate = (dateText: string): string => {
  try {
    const date = new Date(dateText);

    // 不正日付判定
    if (date.toString() === 'Invalid Date') {
      return '';
    }

    const dayNames = '日月火水木金土';
    return `${date.getMonth() + 1}/${date.getDate()}(${
      dayNames[date.getDay()]
    })更新`;
  } catch (e) {
    return '';
  }
};

/**
 * 保存検索条件処理用日付編集
 * @returns {string}
 */
export function editDate() {
  const objDate = new Date();

  const year = objDate.getFullYear();
  let month: string | number = objDate.getMonth() + 1;
  let date: string | number = objDate.getDate();
  let hours: string | number = objDate.getHours();
  let minutes: string | number = objDate.getMinutes();
  let seconds: string | number = objDate.getSeconds();

  if (month < 10) {
    month = `0${month}`;
  }
  if (date < 10) {
    date = `0${date}`;
  }
  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }

  return `${year}${month}${date}${hours}${minutes}${seconds}`;
}

/**
 * "YYYY-MM-DD"形式の日付を"YYYY/MM/DD"へ変換する
 * @param {string}  dateText
 * @returns {string}
 */
export const convertHyphenToSlash = (dateText: string) =>
  dateText.replace(/[-ー]/g, '/');

/**
 * "YYYY/MM/DD（曜日）"形式の日付をdate型に変換する
 * @param {string}  dateText
 * @returns {Date}
 */
export const convertStrDateToDate = (dateText: string) =>
  new Date(dateText.slice(0, -3));

/**
 * 年月日形式の文字列作成
 * @returns {string} 年月日形式の文字列（例：「2022年7月1日」）
 */
export function createDataToJpDateFormat() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const date = today.getDate();

  return `${year}年${month}月${date}日`;
}

/**
 * "YYYYMMDDhhmmss"形式の14桁の文字列を"YYYY/MM/DD hh:mm:ss"へ変換する
 * @param {string} dateStr
 * @returns {string} YYYY/MM/DD hh:mm:ss形式の日時
 */
export const generateDateText = (dateStr: string) => {
  if (dateStr === '') {
    return '';
  }
  const YYYY = dateStr.substring(0, 4);
  const MM = dateStr.substring(4, 6);
  const DD = dateStr.substring(6, 8);
  const hh = dateStr.substring(8, 10);
  const mm = dateStr.substring(10, 12);
  const ss = dateStr.substring(12, 14);
  return `${YYYY}/${MM}/${DD} ${hh}:${mm}:${ss}`;
};

/**
 * yyyy年M月に変換
 * @param {string} dateString
 * @returns {string} yyyy年M月
 */
export const formatDateTextToJpYearMonth = (dateString: string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 月は0から始まるため、1を足します
  return `${year}年${month}月`;
};
